import { gql } from '@apollo/client';

export const GET_AGENT_PORTFOLIO = gql`
    query GetAgentPortfolio($agentId: ID!) {
        agentPortfolio(agentId: $agentId) {
            id
            agentId
            propertyId
            assignedAt
            status
        }
    }
`;

export const GET_PROPERTY_ASSIGNMENTS = gql`
    query GetPropertyAssignments($propertyId: ID!) {
        propertyAssignments(propertyId: $propertyId) {
            id
            agentId
            propertyId
            assignedAt
            status
        }
    }
`;
